export default __webpack_public_path__ + "assets/images/business-infos-image5f6f52eec0f7774e2c6d2d3b783756dd.png";